import React from "react";

import ChevronLeft from "@material-ui/icons/ChevronLeft";

import {
  Show,
  TextField,
  TopToolbar,
  ListButton,
  SimpleShowLayout,
  EditButton,
  useNotify,
  useRefresh,
  useRedirect,
} from "react-admin";

const CatalogSamplesTitle = ({ record }) => {
  return <span>Provider {record ? `"${record.code}"` : ""}</span>;
};

const CatalogSamplesActions = ({ basePath, data }) => (
  <TopToolbar>
    <ListButton basePath={basePath} label="Back" icon={<ChevronLeft />} />
    <EditButton basePath={basePath} record={data} />
  </TopToolbar>
);

const CatalogSamplesShow = (props) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const onFailure = (error) => {
    notify(`Catalog Sample ${error.message}`, "error");
    sleep(2500).then(() => {
      redirect("/catalog_samples");
      refresh();
    });
  };

  return (
    <Show
      title={<CatalogSamplesTitle />}
      onFailure={onFailure}
      actions={<CatalogSamplesActions />}
      {...props}
    >
      <SimpleShowLayout>
        <TextField label="Code" source="code" />
        <TextField lable="Short Description" source="short_description" />
       </SimpleShowLayout>
    </Show>
  );
};

export default CatalogSamplesShow;
